import { Topbar } from '@/components/organisms/Topbar';
import { SectionCard } from '../common';
import { ListRowsSkeleton } from '../section-skeletons';

/**
 * `/templates` route pending state: Topbar + the same collection-list block
 * `TemplatesSection` renders, so nothing resizes on handover.
 */
export function TemplatesPendingState() {
  return (
    <>
      <Topbar crumbs={[{ label: 'Workspace' }, { label: 'Templates' }]} title="Templates" />
      <div className="flex min-h-0 flex-1 flex-col overflow-auto" style={{ background: 'var(--canvas)' }}>
        <div
          className="mx-auto flex w-full flex-col gap-6 px-4 py-6 md:px-8 md:py-6"
          aria-busy="true"
          aria-live="polite"
        >
          <SectionCard tight>
            <ListRowsSkeleton rows={3} />
          </SectionCard>
        </div>
      </div>
    </>
  );
}
